<script>
import FieldError from "./FieldError.vue";

export default {
  name: "Input",
  components: { FieldError },
  props: {
    alignRight: Boolean,
    onChange: Function,
    value: String,
    placeholder: String,
    label: String,
    validate: Function | undefined,
    errorText: String | undefined,
  },
  methods: {
    onInputChange(e) {
      this.onChange(e.target.value);
    },
  },
};
</script>

<template>
  <div class="container">
    <div class="label">{{ label }}</div>
    <input
      type="text"
      v-bind:class="{ 'input-container': true, 'input-error-container': errorText , 'right-aligned': alignRight }"
      :value="value"
      :placeholder="placeholder"
      @input="onInputChange"
      @blur="validate"
    />
    <FieldError :text="errorText" v-if="errorText" />
  </div>
</template>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.label {
  color: #000025;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px; /* 133.333% */
  letter-spacing: 2px;
  text-transform: uppercase;
  opacity: 0.5;
}
.input-container {
  font-family: "sofia-pro", sans-serif;
  font-size: 16px;
  line-height: 24px;
  margin-top: 8px;
  height: 42px;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  border: 2px solid rgba(0, 0, 37, 0.05);
  border-radius: 8px;
  padding: 8px;
  font-weight: 600;

  &:focus {
    border: 2px solid #773dff;
    opacity: 1;
  }
}
.input-error-container {
  border: 2px solid #ff4e4e;

  &:focus {
    border: 2px solid #ff4e4e;
  }
}
.right-aligned {
  text-align: right;
}
</style>
